<script setup lang="ts">
    import AppLayout from '@/layouts/AppLayout.vue';
    import { type AuthUser, type BreadcrumbItem } from '@/types';
    import { Head } from '@inertiajs/vue3';
    import ProfileInformationForm from '@/components/ProfileInformationForm.vue';
    import ProfilePasswordForm from '@/components/ProfilePasswordForm.vue';

    const props = defineProps<{
        user: AuthUser;
    }>();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'profile.profile_settings',
            href: route('v2.profile.index'),
        },
    ];
</script>

<template>
    <Head :title="$t('profile.profile_settings')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <div class="flex h-full min-h-0 w-full flex-1 flex-col gap-1.5 overflow-auto py-1.5">
            <ProfileInformationForm :user="user" />
            <ProfilePasswordForm />
        </div>
    </AppLayout>
</template>
